export default __webpack_public_path__ + "static/media/boy_s.04807b15.png";